import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {connect} from 'react-redux';

import {RootState} from 'App/store/rootReducer';

const initialState = {
  isPublicOwnersPageAvailable: false,
  isSignupAvailable: false,
  allHelpersAvailable: false,
  isCustomFiltersAvailable: false,
  isAdvancedCampaignRulesAvailable: false,
  isHeadlessPdfAvailable: false,
  isRestoredPdfAvailable: false,
  isRedesignAvailable: false,
  isParcelAutoDivisionAvailable: false,
  isOfficesAndCommercialTypologyAvailable: true,
  isExportToOCLAvailable: true,
};

export type FeatureFlags = typeof initialState;

export type FeatureFlagKey = keyof FeatureFlags;

type ToggleAction = PayloadAction<{
  key: FeatureFlagKey;
  value: boolean;
}>;

const featureFlagsSlice = createSlice({
  name: 'featureFlags',
  initialState,
  reducers: {
    toggle: (state, action: ToggleAction) => {
      const {key, value} = action.payload;
      state[key] = value;
    },
  },
});

const mapFeatureFlagsToProps = (state: RootState): FeatureFlags =>
  state.featureFlags;
export const connectToFeatureFlags = connect(
  mapFeatureFlagsToProps,
  null,
  null,
  {forwardRef: true},
);

export const selectAllFeatureFlags = (state: RootState): FeatureFlags =>
  state.featureFlags;

export const selectFeatureFlag =
  (key: FeatureFlagKey) =>
  (state: RootState): boolean =>
    state.featureFlags[key];

export const {toggle} = featureFlagsSlice.actions;

export default featureFlagsSlice.reducer;
